import type {ReactAction} from '@netx/core/bootstrap';
import {appRouter} from '@netx/core-next/instance/router';
import {faArrowUpFromBracket} from '@netx/core-icons';
import {canUploadAssets} from '../enablers';
import {UploadAssetLabel} from '../locales';

export const uploadAssetActionRouteIcon = faArrowUpFromBracket;

/**
 * Route to uploads
 * @param params
 * @returns Action
 */
export const uploadAssetActionRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'upload-asset-route',
	cb: () => appRouter.navigate('upload/status', true),
	enableTest: () => canUploadAssets(),
	icon: uploadAssetActionRouteIcon,
	get label() {
		return UploadAssetLabel.ROUTE;
	},
	routeMatch: /^upload\/status/,
	...params,
});
